import moment from "moment";
import { DATETIME_NOT_SECONDS_FORMAT } from "@/common/constant";
import { MessageDTO } from "@/model/message";

export interface IUserRoomStatus {
  state: string;
  last_changed: string;
}

export class UserRoomStatusDTO implements IUserRoomStatus {
  state: string;
  last_changed: string;
}

export interface IUserRoom {
  _id: string;
  username: string;
  avatar: string;
  status: UserRoomStatusDTO
}

export class UserRoomDTO implements IUserRoom {
  _id: string;
  username: string;
  avatar: string;
  status: UserRoomStatusDTO
}

export interface IRoom {
  room_id: number,
  room_name: string,
  avatar: string,
  unread_count: number,
  index: number,
  last_message: MessageDTO,
  users: UserRoomDTO[],
  typing_users: string[],
  property_id: string,
  contract_id: string,
  user_type: string,
  is_move_out: boolean,
}

export class RoomDTO implements IRoom {
  room_id: number;
  room_name: string;
  avatar: string;
  unread_count: number;
  index: number;
  last_message: MessageDTO;
  users: UserRoomDTO[];
  typing_users: string[];
  property_id: string;
  contract_id: string;
  user_type: string;
  is_move_out: boolean;
}

export default class Room extends RoomDTO {

  constructor(dto?: RoomDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      room_id: null,
      room_name: "",
      avatar: "",
      unread_count: 0,
      index: 0,
      last_message: {
        content: "",
        sender_id: "",
        username: "",
        timestamp: "",
        saved: false,
        distributed: false,
        seen: false,
        new: false
      },
      users: []
    })
  }

  public formatDate(date) {
    return moment(date).format(DATETIME_NOT_SECONDS_FORMAT)
  }
}